import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';
import { setIsBabyBorn } from '../api/setIsBabyBorn';

export const isBabyBornMutationAtom = atomWithMutation<void, boolean, Error>(
    (get) => ({
        mutationFn: async (isBabyBorn: boolean) => {
            await setIsBabyBorn(isBabyBorn);
        },
        onSuccess: async () =>
            await get(queryClientAtom).invalidateQueries({
                queryKey: ['newborn-program'],
            }),
    }),
);
